<template>
  <div>
    <label style="display: flex; position: relative; align-items: center; min-height: 40px; border: 1px solid #cdcdcd; border-radius: 5px">
      <div class="flex flex-wrap gap-1 p-2">
        <vs-chip v-for="field in fields" :key="field.id" color="#7E72F2" class="chip" @click.native="fieldRemove(field)">
          {{ field.field_name }}
          <vs-icon icon="close" size="x-small" class="ml-1"></vs-icon>
        </vs-chip>
      </div>
      <vs-icon
        @click="handleClickInput"
        icon-pack="feather"
        icon="icon-home"
        style="padding-left: 6px; padding-right: 6px; position: absolute; top: auto; right: 0; bottom: auto; font-size: 24px; border-left: 1px solid #cdcdcd"
        class="cursor-pointer"
      ></vs-icon>
    </label>

    <popup-search-field v-if="!fieldTypes" v-model="showPopup" :use-types="useTypes" @handleClickSelect="handleClickSelect" />
    <popup-search-field-by-type v-else v-model="showPopup" multiple :field-types="fieldTypes" :project-info="projectInfo" :menu-title="menuTitle" :selectDatas="fields" @handleClickMultipleSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchField from "@/popup/PopupSearchField";
import PopupSearchFieldByType from "@/popup/PopupSearchFieldByType.vue";

export default {
  name: "FieldSelectorMultiple",
  components: { PopupSearchFieldByType, PopupSearchField },
  props: {
    value: Array,
    fieldName: String,
    readonly: Boolean,
    popupTitle: {
      type: String,
      default: "",
    },
  },
  watch: {
    value: {
      handler(value) {
        this.fields = value;
      },
    },
    fields: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    fieldListInfo() {
      return this.$store.state.project.fieldListInfo;
    },
    fieldTypes() {
      return this.projectInfo.field_types;
    },
    type() {
      // 2023-03-06 추가된 방식.. FieldType 모델과 M:N 관계에 따라서 탭 목록이 변경된다
      if (typeof this.projectInfo.field_types !== "undefined") {
        const fieldTypes = this.projectInfo.field_types;
        if (fieldTypes && fieldTypes.length > 0) {
          return fieldTypes.map((item) => item.name);
        }
      }

      // 기존 방식.. project_type에 따라서 표시되는 탭 목록이 변경된다
      if (typeof this.projectInfo.project_type !== "undefined") {
        if (this.projectInfo.project_type.indexOf("Standard Ver") >= 0) {
          //ProjectId = 1
          return ["사업장(직접수행)", "사업장(용역위탁)", "사업장(도급발주)", "시설물"];
        } else if (this.projectInfo.project_type.indexOf("Data Base Team") >= 0) {
          //ProjectId = 2
          return ["사업장(직접수행)"];
        } else if (this.projectInfo.project_type.indexOf("파트너입찰(1억이하)") >= 0) {
          //ProjectId = 3
          return ["사업장(용역위탁)"];
        } else if (this.projectInfo.project_type.indexOf("파트너입찰(1억이상)") >= 0) {
          //ProjectId = 4
          return ["사업장(도급발주)"];
        } else if (this.projectInfo.project_type.indexOf("삼성 에스원") >= 0) {
          //ProjectId = 5
          return ["시설물"];
        }
      }
    },
    useTypes() {
      if (typeof this.type === "string") {
        return [this.type];
      } else {
        return this.type;
      }
    },
    menuTitle() {
      return this.popupTitle;
    },
    selectIds() {
      this.fields.map((item) => item.id);
    },
  },
  data() {
    return {
      showPopup: false,
      fields: this.value,
    };
  },
  methods: {
    handleClickInput() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    handleClickSelect(fields) {
      this.fields = fields;
    },
    fieldRemove(data) {
      this.fields = this.fields.filter((item) => item.id !== data.id);
    },
  },
};
</script>

<style scoped>
.chip {
  margin: 0px;
  cursor: pointer;
}
</style>
